export default __webpack_public_path__ + "static/media/people.c9d4c4a5.svg";